import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.081 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86631 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6152_23707)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6152_23707)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6152_23707)"
      />
      <path
        d="M243.855 19.6001C243.675 19.6001 243.6 19.6752 243.6 19.8563C243.6 49.2857 243.6 78.7151 243.6 108.145C243.6 108.325 243.675 108.4 243.855 108.4C273.285 108.4 302.714 108.4 332.143 108.4C332.324 108.4 332.399 108.325 332.399 108.145C332.399 78.7151 332.399 49.2857 332.399 19.8563C332.399 19.6752 332.324 19.6001 332.143 19.6001C302.714 19.6001 273.285 19.6001 243.855 19.6001Z"
        fill="#575756"
      />
      <path
        d="M331.999 107.744C331.999 107.924 331.924 107.999 331.743 107.999C302.58 107.999 273.418 107.999 244.255 107.999C244.075 107.999 244 107.924 244 107.744C244 78.5814 244 49.4184 244 20.2559C244 20.0753 244.075 20.0002 244.255 20.0002C273.418 20.0002 302.58 20.0002 331.743 20.0002C331.924 20.0002 331.999 20.0753 331.999 20.2559C331.999 49.4184 331.999 78.5814 331.999 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M332.399 107.744C332.399 107.924 332.324 107.999 332.143 107.999C302.981 107.999 273.818 107.999 244.656 107.999C244.475 107.999 244.4 107.924 244.4 107.744C244.4 78.5814 244.4 49.4184 244.4 20.2559C244.4 20.0753 244.475 20.0002 244.656 20.0002C273.818 20.0002 302.981 20.0002 332.143 20.0002C332.324 20.0002 332.399 20.0753 332.399 20.2559C332.399 49.4184 332.399 78.5814 332.399 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M244.256 20C244.075 20 244 20.075 244 20.2556C244 49.685 244 79.1139 244 108.543C244 108.724 244.075 108.8 244.256 108.8C273.685 108.8 303.114 108.8 332.543 108.8C332.724 108.8 332.799 108.724 332.799 108.543C332.799 79.1139 332.799 49.685 332.799 20.2556C332.799 20.075 332.724 20 332.543 20C303.114 20 273.685 20 244.256 20Z"
        fill="#575756"
      />
      <path
        d="M332.4 108.143C332.4 108.324 332.325 108.399 332.143 108.399C302.981 108.399 273.818 108.399 244.656 108.399C244.475 108.399 244.4 108.324 244.4 108.143C244.4 78.9806 244.4 49.8182 244.4 20.6558C244.4 20.4751 244.475 20.4001 244.656 20.4001C273.818 20.4001 302.981 20.4001 332.143 20.4001C332.325 20.4001 332.4 20.4751 332.4 20.6558C332.4 49.8182 332.4 78.9806 332.4 108.143Z"
        fill="#E3E3E3"
      />
      <path
        d="M319.338 98.691C317.879 98.691 316.421 98.691 314.962 98.691C315.052 97.8268 315.143 96.9628 315.234 96.0992C315.429 94.2371 318.137 94.0689 318.504 95.9112C318.589 96.3227 319.124 96.439 319.367 96.0946C319.442 95.9885 319.467 95.8892 319.452 95.7599C319.419 95.4969 319.326 95.2688 319.208 95.0385C318.818 94.2788 318.313 93.9147 317.489 93.7273C315.907 93.3678 314.45 94.3741 314.279 95.9986C314.17 97.0394 314.059 98.0803 313.95 99.1205C313.912 99.4874 314.058 99.6507 314.428 99.6507C314.933 99.6507 315.436 99.6507 315.94 99.6507C315.988 100.905 317.778 100.905 317.824 99.6507C318.33 99.6507 318.833 99.6507 319.337 99.6507C319.677 99.6507 319.818 99.5101 319.818 99.1703C319.818 98.8305 319.677 98.691 319.338 98.691Z"
        fill="#575756"
      />
      <path
        d="M321.15 89.792C320.866 89.6069 320.671 89.647 320.486 89.9315C320.3 90.2154 320.341 90.4101 320.625 90.5958C322.297 91.6875 323.135 92.9596 323.526 94.9103C323.592 95.2428 323.757 95.3534 324.09 95.2868C324.423 95.2196 324.533 95.0543 324.467 94.7218C324.061 92.6904 322.891 90.9277 321.15 89.792Z"
        fill="#575756"
      />
      <path
        d="M309.3 94.7218C309.233 95.0543 309.344 95.2202 309.676 95.2868C310.009 95.3534 310.174 95.2433 310.241 94.9103C310.63 92.9596 311.47 91.6869 313.141 90.5958C313.425 90.4101 313.466 90.2154 313.281 89.9315C313.095 89.647 312.901 89.6063 312.616 89.792C310.875 90.9277 309.705 92.6904 309.3 94.7218Z"
        fill="#575756"
      />
      <path
        d="M311.844 95.0657C311.767 95.3964 311.875 95.5624 312.204 95.6414C312.535 95.7204 312.703 95.6127 312.779 95.2819C313.054 94.1011 313.581 93.3311 314.619 92.6905C314.907 92.5121 314.952 92.3179 314.773 92.0295C314.595 91.7399 314.402 91.6948 314.113 91.8749C312.832 92.6628 312.18 93.6094 311.844 95.0657Z"
        fill="#575756"
      />
      <path
        d="M319.654 91.8748C319.365 91.6953 319.171 91.741 318.992 92.0289C318.814 92.3179 318.859 92.511 319.147 92.6905C320.186 93.3311 320.715 94.0981 320.986 95.2812C321.062 95.6119 321.231 95.7164 321.562 95.6419C321.894 95.5663 321.998 95.3969 321.923 95.0662C321.587 93.6077 320.93 92.665 319.654 91.8748Z"
        fill="#575756"
      />
      <path
        d="M270.946 62.6726C268.619 62.6732 268.582 66.1118 270.908 66.1637C273.234 66.2156 273.274 62.6732 270.946 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M288.4 80.1089C286.073 80.1089 286.035 83.5481 288.362 83.5994C290.688 83.6508 290.727 80.1089 288.4 80.1089Z"
        fill="#3C3C3B"
      />
      <path
        d="M283.964 57.4371C283.964 55.1099 283.964 52.7827 283.964 50.4555C283.964 49.4909 283.182 48.7097 282.219 48.7097C281.254 48.7097 280.472 49.4909 280.472 50.4555C280.472 52.7827 280.472 55.1099 280.472 57.4371C280.472 58.4006 281.254 59.1823 282.219 59.1823C283.182 59.1823 283.964 58.4006 283.964 57.4371Z"
        fill="#3C3C3B"
      />
      <path
        d="M302.508 74.8726C302.508 72.5454 302.508 70.2183 302.508 67.8911C302.508 66.927 301.726 66.1453 300.762 66.1453C299.798 66.1453 299.016 66.927 299.016 67.8911C299.016 70.2183 299.016 72.5454 299.016 74.8726C299.016 75.8367 299.798 76.6184 300.762 76.6184C301.727 76.6179 302.508 75.8367 302.508 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M277.783 74.8726C277.783 72.5454 277.783 70.2183 277.783 67.8911C277.783 66.927 277.001 66.1453 276.038 66.1453C275.073 66.1453 274.292 66.927 274.292 67.8911C274.292 70.2183 274.292 72.5454 274.292 74.8726C274.292 75.8367 275.073 76.6184 276.038 76.6184C277.001 76.6179 277.783 75.8367 277.783 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M296.327 57.4371C296.327 55.1099 296.327 52.7827 296.327 50.4555C296.327 49.4909 295.545 48.7097 294.581 48.7097C293.617 48.7097 292.835 49.4909 292.835 50.4555C292.835 52.7827 292.835 55.1099 292.835 57.4371C292.835 58.4006 293.617 59.1823 294.581 59.1823C295.545 59.1823 296.327 58.4006 296.327 57.4371Z"
        fill="#3C3C3B"
      />
      <path
        d="M299.017 53.9267C299.017 56.2539 299.017 58.581 299.017 60.9082C299.017 61.8728 299.798 62.654 300.763 62.654C301.726 62.654 302.508 61.8728 302.508 60.9082C302.508 58.581 302.508 56.2539 302.508 53.9267C302.508 52.9632 301.726 52.1814 300.763 52.1814C299.798 52.1814 299.017 52.9632 299.017 53.9267Z"
        fill="#3C3C3B"
      />
      <path
        d="M292.835 71.4001C292.835 73.7273 292.835 76.0544 292.835 78.3816C292.835 79.3456 293.617 80.1274 294.582 80.1274C295.545 80.1274 296.327 79.3456 296.327 78.3816C296.327 76.0544 296.327 73.7273 296.327 71.4001C296.327 70.436 295.545 69.6548 294.582 69.6548C293.617 69.6553 292.835 70.436 292.835 71.4001Z"
        fill="#3C3C3B"
      />
      <path
        d="M290.145 74.8726C290.145 72.5454 290.145 70.2183 290.145 67.8911C290.145 66.927 289.363 66.1453 288.4 66.1453C287.435 66.1453 286.654 66.927 286.654 67.8911C286.654 70.2183 286.654 72.5454 286.654 74.8726C286.654 75.8367 287.435 76.6184 288.4 76.6184C289.363 76.6179 290.145 75.8367 290.145 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M290.145 60.9082C290.145 58.581 290.145 56.2539 290.145 53.9267C290.145 52.9632 289.363 52.1814 288.4 52.1814C287.435 52.1814 286.654 52.9632 286.654 53.9267C286.654 56.2539 286.654 58.581 286.654 60.9082C286.654 61.8728 287.435 62.654 288.4 62.654C289.363 62.654 290.145 61.8728 290.145 60.9082Z"
        fill="#3C3C3B"
      />
      <path
        d="M283.964 78.3816C283.964 76.0544 283.964 73.7273 283.964 71.4001C283.964 70.436 283.182 69.6548 282.219 69.6548C281.254 69.6548 280.472 70.436 280.472 71.4001C280.472 73.7273 280.472 76.0544 280.472 78.3816C280.472 79.3456 281.254 80.1274 282.219 80.1274C283.182 80.1274 283.964 79.3456 283.964 78.3816Z"
        fill="#3C3C3B"
      />
      <path
        d="M277.783 60.9082C277.783 58.581 277.783 56.2539 277.783 53.9267C277.783 52.9632 277.001 52.1814 276.038 52.1814C275.073 52.1814 274.292 52.9632 274.292 53.9267C274.292 56.2539 274.292 58.581 274.292 60.9082C274.292 61.8728 275.073 62.654 276.038 62.654C277.001 62.654 277.783 61.8728 277.783 60.9082Z"
        fill="#3C3C3B"
      />
      <path
        d="M305.852 62.6755C303.526 62.6755 303.488 66.1147 305.814 66.1666C308.141 66.218 308.18 62.6755 305.852 62.6755Z"
        fill="#3C3C3B"
      />
      <path
        d="M282.219 62.6726C279.892 62.6732 279.853 66.1118 282.18 66.1637C284.506 66.2156 284.546 62.6732 282.219 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M294.581 62.6726C292.254 62.6732 292.216 66.1118 294.543 66.1637C296.869 66.2156 296.908 62.6732 294.581 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M288.4 45.2C286.073 45.2 286.035 48.6384 288.362 48.6904C290.688 48.7423 290.727 45.2 288.4 45.2Z"
        fill="#3C3C3B"
      />
      <path
        d="M220.399 107.744C220.399 107.924 220.324 107.999 220.143 107.999C190.981 107.999 161.818 107.999 132.656 107.999C132.475 107.999 132.4 107.924 132.4 107.744C132.4 78.5814 132.4 49.4184 132.4 20.2559C132.4 20.0753 132.475 20.0002 132.656 20.0002C161.818 20.0002 190.981 20.0002 220.143 20.0002C220.324 20.0002 220.399 20.0753 220.399 20.2559C220.399 49.4184 220.399 78.5814 220.399 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M132.256 20C132.075 20 132 20.075 132 20.2556C132 49.685 132 79.1139 132 108.543C132 108.724 132.075 108.8 132.256 108.8C161.685 108.8 191.114 108.8 220.543 108.8C220.724 108.8 220.799 108.724 220.799 108.543C220.799 79.1139 220.799 49.685 220.799 20.2556C220.799 20.075 220.724 20 220.543 20C191.114 20 161.685 20 132.256 20Z"
        fill="#575756"
      />
      <path
        d="M220.4 108.143C220.4 108.324 220.325 108.399 220.143 108.399C190.981 108.399 161.818 108.399 132.656 108.399C132.475 108.399 132.4 108.324 132.4 108.143C132.4 78.9806 132.4 49.8182 132.4 20.6558C132.4 20.4751 132.475 20.4001 132.656 20.4001C161.818 20.4001 190.981 20.4001 220.143 20.4001C220.325 20.4001 220.4 20.4751 220.4 20.6558C220.4 49.8182 220.4 78.9806 220.4 108.143Z"
        fill="#E3E3E3"
      />
      <path
        d="M131.855 20.0002C131.675 20.0002 131.6 20.0753 131.6 20.2565C131.6 49.6859 131.6 79.1153 131.6 108.545C131.6 108.725 131.675 108.8 131.855 108.8C161.285 108.8 190.714 108.8 220.143 108.8C220.324 108.8 220.399 108.725 220.399 108.545C220.399 79.1153 220.399 49.6859 220.399 20.2565C220.399 20.0753 220.324 20.0002 220.143 20.0002C190.714 20.0002 161.285 20.0002 131.855 20.0002Z"
        fill="#575756"
      />
      <path
        d="M219.999 108.144C219.999 108.325 219.924 108.4 219.743 108.4C190.58 108.4 161.418 108.4 132.255 108.4C132.075 108.4 132 108.325 132 108.144C132 78.9815 132 49.8185 132 20.6561C132 20.4755 132.075 20.4004 132.255 20.4004C161.418 20.4004 190.58 20.4004 219.743 20.4004C219.924 20.4004 219.999 20.4755 219.999 20.6561C219.999 49.8185 219.999 78.9815 219.999 108.144Z"
        fill="#E3E3E3"
      />
      <path
        d="M131.857 20C131.676 20 131.601 20.0751 131.601 20.2563C131.601 49.6858 131.601 79.1147 131.601 108.544C131.601 108.725 131.676 108.8 131.857 108.8C161.287 108.8 190.715 108.8 220.145 108.8C220.327 108.8 220.401 108.725 220.401 108.544C220.401 79.1147 220.401 49.6858 220.401 20.2563C220.401 20.0751 220.327 20 220.145 20C190.716 20 161.287 20 131.857 20Z"
        fill="#575756"
      />
      <path
        d="M219.745 20.6558V20.4001H132.258"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.745 20.4001C219.926 20.4001 220.001 20.4752 220.001 20.6558C220.001 49.819 220.001 78.9815 220.001 108.144C220.001 108.325 219.926 108.4 219.745 108.4C190.582 108.4 161.42 108.4 132.257 108.4C132.077 108.4 132.001 108.325 132.001 108.144C132.001 78.9815 132.001 49.819 132.001 20.6558C132.001 20.4752 132.077 20.4001 132.257 20.4001"
        fill="#E3E3E3"
      />
      <path
        d="M176.001 95.2799C193.056 95.2799 206.881 81.4546 206.881 64.4003C206.881 47.346 193.056 33.5208 176.001 33.5208C158.947 33.5208 145.122 47.346 145.122 64.4003C145.122 81.4546 158.947 95.2799 176.001 95.2799Z"
        fill="url(#paint3_linear_6152_23707)"
      />
      <path
        d="M160.641 68.9599C163.16 68.9599 165.201 66.9183 165.201 64.3998C165.201 61.8813 163.16 59.8396 160.641 59.8396C158.123 59.8396 156.081 61.8813 156.081 64.3998C156.081 66.9183 158.123 68.9599 160.641 68.9599Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.362 68.9599C193.88 68.9599 195.922 66.9183 195.922 64.3998C195.922 61.8813 193.88 59.8396 191.362 59.8396C188.843 59.8396 186.802 61.8813 186.802 64.3998C186.802 66.9183 188.843 68.9599 191.362 68.9599Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.67 98.4239C208.258 98.8365 208.258 99.5065 208.67 99.9197C209.084 100.333 209.751 100.331 210.165 99.9185C210.578 99.5065 210.579 98.8365 210.166 98.4239C209.753 98.0107 209.084 98.0107 208.67 98.4239Z"
        fill="#575756"
      />
      <path
        d="M205.655 98.6915C204.923 98.6915 204.191 98.6915 203.459 98.6915C203.33 98.6909 203.277 98.6379 203.277 98.5097C203.277 96.7441 203.277 94.9792 203.277 93.2141C203.277 93.0849 203.33 93.0324 203.459 93.0324C205.224 93.0324 206.989 93.0324 208.754 93.0324C208.883 93.0324 208.935 93.0854 208.936 93.2141C208.936 93.9462 208.936 94.6789 208.936 95.4115C208.936 95.7513 209.076 95.8918 209.416 95.8918C209.755 95.8918 209.896 95.7513 209.896 95.4115C209.896 94.6789 209.896 93.9462 209.896 93.2141C209.895 92.5837 209.384 92.0734 208.755 92.0723C206.99 92.0723 205.225 92.0723 203.46 92.0723C202.829 92.0728 202.318 92.5837 202.318 93.2141C202.318 94.9792 202.318 96.7441 202.318 98.5097C202.318 99.1396 202.829 99.651 203.46 99.6516C204.192 99.6516 204.924 99.6516 205.656 99.6516C205.994 99.6516 206.136 99.511 206.136 99.1713C206.136 98.8315 205.993 98.6915 205.655 98.6915Z"
        fill="#575756"
      />
      <path
        d="M179.122 42.0005V33.6879C178.09 33.5824 177.05 33.5203 176.002 33.5203C174.949 33.5203 173.908 33.5739 172.882 33.6766V41.9999H179.122V42.0005Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.601 59.7104C149.601 55.9314 149.601 52.1519 149.601 48.3735C147.456 51.8996 146.005 55.8925 145.419 60.1603C146.663 60.1603 147.907 60.1603 149.151 60.1603C149.469 60.1597 149.601 60.0287 149.601 59.7104Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.895 60.1597C204.126 60.1597 205.358 60.1597 206.589 60.1597C206.581 60.1066 206.574 60.0536 206.566 60C206.558 59.9469 206.551 59.8933 206.543 59.8402C205.954 55.8925 204.723 52.3743 202.722 48.9205C202.62 48.7461 202.505 48.5795 202.402 48.408C202.402 52.1604 202.402 55.9145 202.402 59.6669C202.402 60.0158 202.546 60.1597 202.895 60.1597Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.881 86.8V95.1234C173.908 95.2261 174.948 95.2797 176.001 95.2797C177.054 95.2797 178.095 95.2255 179.121 95.1234V86.8H172.881Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.075 68.6396C147.856 68.6396 146.637 68.6396 145.418 68.6396C146.005 72.9085 147.455 76.9003 149.601 80.4269C149.601 76.6734 149.601 72.9204 149.601 69.1669C149.601 68.7938 149.447 68.6396 149.075 68.6396Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.013 68.6396C202.581 68.6396 202.402 68.8191 202.402 69.2509C202.402 72.9768 202.402 76.7016 202.402 80.4269C204.547 76.9003 205.998 72.9085 206.584 68.6396C205.394 68.6396 204.203 68.6396 203.013 68.6396Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.104 95.2091C174.734 95.2503 175.366 95.2797 176.001 95.2797C176.639 95.2797 177.27 95.2537 177.898 95.2153V85.6711H174.104V95.2091H174.104Z"
        fill="url(#paint4_linear_6152_23707)"
      />
      <path
        d="M177.899 33.5906C177.269 33.5494 176.637 33.52 176.002 33.52C175.364 33.52 174.733 33.546 174.105 33.5844V43.1285H177.899V33.5906H177.899Z"
        fill="url(#paint5_linear_6152_23707)"
      />
      <path
        d="M19.8553 20C19.6747 20 19.5996 20.0751 19.5996 20.2562C19.5996 49.6856 19.5996 79.115 19.5996 108.544C19.5996 108.725 19.6747 108.8 19.8553 108.8C49.2847 108.8 78.7135 108.8 108.143 108.8C108.324 108.8 108.399 108.725 108.399 108.544C108.399 79.115 108.399 49.6856 108.399 20.2562C108.399 20.0751 108.324 20 108.143 20C78.7135 20 49.2847 20 19.8553 20Z"
        fill="#575756"
      />
      <path
        d="M107.999 108.144C107.999 108.324 107.924 108.399 107.743 108.399C78.5802 108.399 49.4179 108.399 20.2554 108.399C20.0748 108.399 19.9998 108.324 19.9998 108.144C19.9998 78.9813 19.9998 49.8183 19.9998 20.6558C19.9998 20.4752 20.0748 20.4001 20.2554 20.4001C49.4179 20.4001 78.5802 20.4001 107.743 20.4001C107.924 20.4001 107.999 20.4752 107.999 20.6558C107.999 49.8183 107.999 78.9813 107.999 108.144Z"
        fill="#E3E3E3"
      />
      <path
        d="M98.0033 98.2536C98.0033 97.9127 97.8673 97.7665 97.523 97.7665C96.5239 97.7665 95.526 97.7665 94.5275 97.7665C94.5275 97.4933 94.5275 97.2195 94.5275 96.9464C94.5275 96.3509 94.2266 95.9456 93.95 95.4833C93.0063 93.9102 92.8324 92.0888 94.7877 91.2523C96.4623 90.5349 98.325 91.7693 98.3267 93.5896C98.3267 93.7437 98.3115 93.8939 98.2788 94.0451C98.2082 94.3776 98.3194 94.5424 98.6496 94.6141C98.9826 94.6869 99.1502 94.578 99.2179 94.2438C99.8067 91.4702 96.897 89.2367 94.3378 90.4017C93.1502 90.9419 92.3555 92.1006 92.2872 93.4056C92.2517 94.0835 92.4181 94.6536 92.715 95.2479C92.925 95.6679 93.5673 96.383 93.5673 96.9469C93.5673 97.688 93.5673 98.4297 93.5673 99.1714C93.5673 99.5112 93.7079 99.6512 94.0477 99.6512C94.2221 99.6512 94.3959 99.6512 94.5703 99.6512C94.5703 99.7996 94.5703 99.9475 94.5703 100.095C94.5703 100.435 94.7109 100.575 95.0507 100.575C95.5407 100.575 96.0306 100.575 96.5205 100.575C96.8603 100.575 97.0008 100.435 97.0008 100.095C97.0008 99.9475 97.0008 99.7996 97.0008 99.6512C97.1752 99.6512 97.3491 99.6512 97.5235 99.6512C97.8633 99.6512 98.0038 99.5112 98.0038 99.1714C98.0033 98.8649 98.0033 98.559 98.0033 98.2536Z"
        fill="#575756"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6152_23707"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6152_23707"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6152_23707"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6152_23707"
          x1="176.001"
          y1="95.28"
          x2="176.001"
          y2="33.5203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6152_23707"
          x1="176.002"
          y1="95.1472"
          x2="176.002"
          y2="85.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6152_23707"
          x1="176.001"
          y1="33.6524"
          x2="176.001"
          y2="43.1575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
